import * as angular from "angular";
import { EventService } from "../services/event-service";
import { NotifyService } from "../services/notify-service";
import { InfoService } from "../services/info-service";
import { ContactService } from "../services/contact-service";
import { AssetService } from "../services/asset-service";
import { FinancialService } from "../services/financial-service";
import { RoyaltyService } from "../services/royalty-service";
import { RightService } from "../services/rights-service";
import { ContractSharedDataService } from "../services/contract-shared-data-service";
import { AdminService } from "../services/admin-service";
import { SecurityService } from "../services/security-service";
import { WorkflowConfigService } from "../services/workflow-config-service";
import { SecurityConfigService } from "../services/security-config-service";
import { DocGenConfigService } from "../services/doc-gen-config-service";
import { DocGenService } from "../services/doc-gen-service";
import { JobService } from "../services/job-service";
import { ContractService } from "../services/contract-service";
import { WorkflowService } from "../services/workflow-service";
import { AttachmentService } from "../services/attachment-service";
import { FavoriteService } from "../services/favorite-service";
import { RLCookieStore } from "../services/cookie-store";
import { DocumentEntityService } from "../services/document-entity-service";
import { JobSharedDataService } from "../services/job-shared-service";
import { DateLocaleService } from "../services/date-locale-service";
import { CommentService } from "../services/comment-service";
import { SearchService } from "../services/search-service";
import { CustomViewsService } from "../services/custom-views-service";
import { ListService } from "../services/list-service";
import { AlertService } from "../services/alert-service";
import { AclService } from "../services/acl-service";
import { AdminConfigService } from "../services/admin-config-service";
import { LocalCacheService } from "../services/local-cache-service";
import { EntityService } from "../services/entity-service";
import { InventoryService } from "../services/inventory-service";
import { PromiseCache } from "../services/promise-cache";
import { PartyGroupService } from "../services/party-group-service";
import { IdentityService } from "../services/identity-service";
import { AssetSharedDataService } from "../services/asset-shared-data-service";
import { InventorySharedDataService } from "../services/inventory-shared-data-service";
import { ProjectService } from "../services/project-service";
import { ProjectSharedDataService } from "../services/project-shared-data-service";
import { ContactSharedDataService } from "../services/contact-shared-data-service";
import { BulkUploadService } from "../services/bulk-upload-service";
import { EntityCharDataService } from "../services/entity-char-data-service";
import { DataSecurityService } from "../services/data-security-service";
import { EntityConfigService } from "../services/entity-config-service";
import { DateCalcService } from "../services/date-calc-service";
import { CurrencyConversionService } from "../services/currency-conversion-service";
import { VariesByCatalogService } from "../services/varies-by-catalog-service";
import { ReportService } from "../services/report-service";
import { ModalService } from "../services/modal-service";
import { UsageService } from "../services/usage-service";
import { StorageService } from "../services/storage-service";
import { AccountService } from "../services/account-service";
import { SharedUsageService } from "../services/shared-usage-service";
import { AuditHistoryService } from "../services/audit-history-service";
import { RightsFilterService } from "../services/rights-filter-service";
import { SessionCacheService } from "../services/session-cache-service";
import { FinancialPeriodService } from "../services/financial-period-service";

var rlAdminServicesModule = angular.module("rlAdminServices", ["ngResource"]);

// Services
rlAdminServicesModule
	.factory("simpleCache", ["$cacheFactory", ($cacheFactory: ng.ICacheFactoryService) => { return $cacheFactory("simpleCache"); }])
	.service("eventService", EventService)
	.service("notifyService", NotifyService)
	.service("infoService", InfoService)
	.service("contractService", ContractService)
	.service("workflowService", WorkflowService)
	.service("contactService", ContactService)
	.service("assetService", AssetService)
	.service("attachmentService", AttachmentService)
	.service("financialService", FinancialService)
	.service("royaltyService", RoyaltyService)
	.service("rightService", RightService)
	.service("favoriteService", FavoriteService)
	.service("rlCookieStore", RLCookieStore)
	.service("contractSharedDataService", ContractSharedDataService)
	.service("adminService", AdminService)
	.service("securityService", SecurityService)
	.service("workflowConfigService", WorkflowConfigService)
	.service("securityConfigService", SecurityConfigService)
	.service("docGenConfigService", DocGenConfigService)
	.service("docGenService", DocGenService)
	.service("documentEntityService", DocumentEntityService)
	.service("jobService", JobService)
	.service("jobSharedDataService", JobSharedDataService)
	.service("dateLocaleService", DateLocaleService)
	.service("commentService", CommentService)
	.service("searchService", SearchService)
	.service("customViewsService", CustomViewsService)
	.service("listService", ListService)
	.service("alertService", AlertService)
	.service("aclService", AclService)
	.service("identityService", IdentityService)
	.service("assetSharedDataService", AssetSharedDataService)
	.service("inventorySharedDataService", InventorySharedDataService)
	.service("projectService", ProjectService)
	.service("projectSharedDataService", ProjectSharedDataService)
	.service("contactSharedDataService", ContactSharedDataService)
	.service("partyGroupService", PartyGroupService)
	.service("promiseCache", PromiseCache)
	.service("inventoryService", InventoryService)
	.service("entityService", EntityService)
	.service("localCacheService", LocalCacheService)
	.service("sessionCacheService", SessionCacheService)
	.service("adminConfigService", AdminConfigService)
	.service("bulkUploadService", BulkUploadService)
	.service("entityCharDataService", EntityCharDataService)
	.service("dataSecurityService", DataSecurityService)
	.service("entityConfigService", EntityConfigService)
	.service("dateCalcService", DateCalcService)
	.service("currencyConversionService", CurrencyConversionService)
	.service("variesByCatalogService", VariesByCatalogService)
	.service("reportService", ReportService)
	.service("modalService", ModalService)
	.service("usageService", UsageService)
	.service("storage", StorageService)
	.service("accountService", AccountService)
	.service("sharedUsageService", SharedUsageService)
	.service("auditHistoryService", AuditHistoryService)
	.service("rightsFilterService", RightsFilterService)
	.service("financialPeriodService", FinancialPeriodService);

export default rlAdminServicesModule;